import { DefaultOptions, QueryClient } from "@tanstack/react-query";

export const queryDefaultOptions = {
    queries: {
        retry: false,
        staleTime: 1000 * 60 * 60 * 1, // 1h : might be increased to 24h, but needs testing for SDK sync
        refetchOnWindowFocus: false,
    },
} satisfies DefaultOptions;

const queryClient = new QueryClient({ defaultOptions: queryDefaultOptions });

export default queryClient;
